import { Stack, styled } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const StyledIcon = styled(Stack, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean }>(({ active }) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${NEW_COLORS.BASE.WHITE}`,

  ...(active && {
    background: NEW_COLORS.SECONDARY[500],
    border: `1px solid ${NEW_COLORS.SECONDARY[500]}`,
    '& .MuiTypography-root': {
      fontWeight: 700,
    },
  }),
}));

const StyledBox = styled(Stack)`
  & svg {
    color: ${NEW_COLORS.SEMANTICS.SUCCESS[500]};
    margin: -6px;
  }
`;

export { StyledIcon, StyledBox };
